import React, { memo } from 'react'
import { format } from 'date-fns'
import { Map } from 'immutable'

const Slot = memo(({ slot, value, onChange, branchId, selectBranch }) => {
  if (!slot.available) return <td></td>
  const date = format(slot.start, 'yyyy-MM-dd')
  const startTime = format(slot.start, 'HH:mm')
  const endTime = format(slot.end, 'HH:mm')
  const id = `${date}-${startTime}-${endTime}`
  const checked =
    (value && value.get('start') === slot.start.toISOString() && value.get('end') === slot.end.toISOString()) || false
  const onChangeHandler = (_event) => {
    onChange(Map({ start: slot.start.toISOString(), end: slot.end.toISOString(), available: true }))
    if (branchId) selectBranch(branchId)
  }
  return (
    <td>
      <div className="atp-input__radios atp-input--vertical">
        <label className="atp-input__label ">
          <input
            id={id}
            type="radio"
            name="timeslots"
            className="atp-input__radio"
            tabIndex="0"
            checked={checked}
            onChange={onChangeHandler}
          />
          <span className="atp-input__label__text"></span>
        </label>
      </div>
    </td>
  )
})
Slot.displayName = 'Slot'

export default Slot
